module.exports = __webpack_public_path__ + "static/media/e5.bcd1c2ee.png";